// extracted by mini-css-extract-plugin
export default {"col":"Summary_col__zLMT7","row":"Summary_row__08QMU","phase3":"Summary_phase3__zitg+"};